var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_2195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.8822L4.30063 16.7027C4.30063 16.7152 4.2975 16.7335 4.29125 16.7584C4.28512 16.7832 4.28186 16.8012 4.28186 16.814V25.7456C4.28186 26.0681 4.39976 26.3476 4.6355 26.583C4.87117 26.8184 5.15025 26.9369 5.47281 26.9369H12.618V19.7914H17.3821V26.9372H24.5272C24.8496 26.9372 25.1291 26.819 25.3645 26.583C25.6002 26.3479 25.7185 26.0682 25.7185 25.7456V16.814C25.7185 16.7644 25.7117 16.727 25.6997 16.7027L15 7.8822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.793 14.693L25.7182 11.3064V3.71429C25.7182 3.54073 25.6624 3.398 25.5504 3.28629C25.4393 3.17471 25.2966 3.11892 25.1227 3.11892H21.55C21.3763 3.11892 21.2336 3.17471 21.1218 3.28629C21.0103 3.398 20.9546 3.5408 20.9546 3.71429V7.3428L16.4143 3.54666C16.0178 3.22411 15.5463 3.06287 15.0004 3.06287C14.4546 3.06287 13.9832 3.22411 13.5863 3.54666L0.206772 14.693C0.0827436 14.7921 0.0147659 14.9254 0.00212194 15.0929C-0.0104569 15.2603 0.0328846 15.4065 0.132277 15.5304L1.28594 16.9075C1.38533 17.0191 1.51542 17.0873 1.67673 17.1123C1.82566 17.1248 1.97458 17.0812 2.12351 16.982L15 6.24492L27.8767 16.982C27.9762 17.0685 28.1062 17.1117 28.2675 17.1117H28.3234C28.4845 17.0872 28.6143 17.0185 28.7142 16.9072L29.868 15.5304C29.9672 15.4062 30.0107 15.2602 29.9978 15.0927C29.985 14.9256 29.9168 14.7923 29.793 14.693Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_2195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhk);
export default __webpack_public_path__ + "static/media/Bhk.c0f363a957ec0f27d74a06f199e58536.svg";
export { ForwardRef as ReactComponent };